<template>
  <div class="remote-approve">
    <!-- <CusModal
      @handleCancel="onClose"
      @handleOk="onClickConfirm"
      :showFooter="false"
      title="Duyệt đơn remote"
      :btnConfirm="$t('commons.label_approve_btn')"
      :btnCancel="$t('commons.label_reject_btn')"
      :isShow="isShow"
    > -->
    <a-modal
      centered
      v-model="isShow"
      :footer="null"
      class="custom-modal"
      title="Duyệt đơn remote"
      @cancel="onClose"
    >
      <ValidationObserver
        tag="form"
        ref="formCreate"
        @submit.prevent="onClickConfirm()"
      >
        <CRow class="form-input">
          <CCol md="12" class="form-field">
            <label class="form-label">
              {{ $t("label.full_name") }}
            </label>
            <b-form-input
              type="text"
              v-model="approveInfo.employee_name"
              placeholder="employee name"
              disabled
            />
          </CCol>
        </CRow>
        <CRow class="form-input">
          <CCol md="12" class="form-field">
            <label class="form-label">
              {{ $t("commons.label_start_date") }}
            </label>
            <b-form-input
              type="text"
              v-model="approveInfo.start_date"
              placeholder="start date"
              disabled
            />
          </CCol>
        </CRow>
        <CRow class="form-input">
          <CCol md="12" class="form-field">
            <label class="form-label">
              {{ $t("commons.label_end_date") }}
            </label>
            <b-form-input
              type="text"
              v-model="approveInfo.end_date"
              placeholder="end date"
              disabled
            />
          </CCol>
        </CRow>

        <CRow class="form-input">
          <CCol md="12" class="form-field">
            <label class="form-label">
              {{ $t("commons.label_reason") }}
              <span class="require">*</span>
            </label>
            <b-form-textarea
              disabled
              class="textarea-input"
              id="textarea"
              rows="1"
              max-rows="4"
              v-model="approveInfo.note"
            >
            </b-form-textarea>
          </CCol>
        </CRow>
        <CRow class="form-input">
          <CCol md="12" class="form-field">
            <label class="form-label">
              {{ $t("commons.label_status") }}
              <span class="require">*</span>
            </label>
            <select class="form-control" v-model="approveInfo.status" disabled>
              <option
                v-for="(option, index) in listRequestStatus"
                :key="index"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
          </CCol>
        </CRow>
        <!-- Overtime approval list-->
        <CRow class="mt-4">
          <CCol md="12" sm="12" class="employees-form approval-ot">
            <div class="text-label">
              <div class="text-center">
                <h4 class="title-header">
                  {{ $t("overtime.information_approval_ot") }}
                </h4>
              </div>
            </div>
            <div class="text-label-content">
              <div class="table-responsive table-employee-note">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="index">#</th>
                      <th class="create-by">
                        {{ $t("overtime.employee_approval") }}
                      </th>
                      <th class="create-at">
                        {{ $t("overtime.employee_approval_status") }}
                      </th>
                      <th>
                        {{ $t("overtime.employee_approval_note") }}
                      </th>
                      <th>
                        {{ $t("overtime.employee_approval_time") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in listEmployeeIdApproval"
                      :key="index"
                    >
                      <th scope="row index">{{ index + 1 }}</th>
                      <td>{{ item.approved_by }}</td>
                      <td>
                        {{ $t(`overtime.employee_approval_${item.status}`) }}
                      </td>
                      <td class="comment">{{ item.comment }}</td>
                      <td v-if ="item.status != 1">{{ item.updated_at | formatDateTime }}</td>
                      <td v-else></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </CCol>
        </CRow>
        <div  v-if="
                  approveInfo &&
                    checkButton &&
                    approveInfo.status === 1 &&
                    checkButton.status === 1
                ">
          <CRow class="form-input">
          <CCol md="12" class="form-field">
            <label class="form-label">
              {{ $t("commons.note") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required|max:255"
              v-slot="{ errors }"
              name="overtime.note"
            >
              <b-form-textarea
                class="textarea-input"
                id="textarea"
                rows="4"
                max-rows="6"
                placeholder=""
                v-model="forms.reason"
              >
              </b-form-textarea>
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
        </CRow>
        <CRow class="text-center">
          <CCol md="12" class="form-data">
            <CButton
              type="submit"
              class="save-info footer-btn"
              @click="onClickConfirm"
            >
              {{ $t("commons.label_approve_btn") }}
            </CButton>
            <CButton
              class="cancel-btn footer-btn"
              type="button"
              @click="onClickReject"
              >{{ $t("commons.label_reject_btn") }}</CButton
            >
          </CCol>
        </CRow>
        </div>
      </ValidationObserver>
    </a-modal>
    <!-- </CusModal> -->
    <CusModal
      @handleCancel="hidePopupNoti"
      @handleOk="hidePopupNoti"
      :title="popupNotiTitle"
      :isShow="isShowPopupNoti"
    >
      <div class="modal-content">
        <div class="warning-title">
          <img src="/img/icons/warning-icon.svg" alt="" />
          {{ popupNoti }}
        </div>
      </div>
    </CusModal>
    <CusModal
      @handleCancel="hideApprovalConfirm"
      @handleOk="submitRemoteRequest"
      :title="approveConfirmTitle"
      :isShow="isShowApprovalConfirm"
    >
      <div class="modal-content">
        <div class="warning-title">
          <img src="/img/icons/warning-icon.svg" alt="" />
          {{ $t("popup.commons.label_confirm_title") }}
        </div>
      </div>
    </CusModal>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import CusModal from "@/components/commons/CusModal.vue";

export default {
  name: "ApproveRemoteRequestModal",
  components: {
    ValidationObserver,
    ValidationProvider,
    CusModal,
  },
  computed: {
    ...mapGetters({
      approveInfo: "remote-request/approveInfo",
    }),
    checkButton()
    {
      const account = this.$store.getters["auth/account"];
      return this.approveInfo.remote_request_approve.filter(
            f => f.employee_id === account.id
          )[0];
    }
    
  },
  beforeDestroy() {
    this.clearData();
  },
  watch: {},
  data() {
    return {
      isShow: false,
      isShowPopupNoti: false,
      isShowApprovalConfirm: false,
      popupNotiTitle: "",
      popupNoti: "",
      approveConfirmTitle: "",
      // approveInfo: {
      //   status: "1",
      //   employee_name: "HieuNV",
      //   start_date: "04/11/2020",
      //   end_date: "04/11/2020",
      //   reason: "Em bị hỏng xe",
      // },
      forms: {
        id: "",
        status: null,
        reason: "",
      },
      listRequestStatus: [
        { id: "1", name: "Chưa duyệt" },
        { id: "2", name: "Đã duyệt" },
        { id: "3", name: "Từ chối" },
      ],
      listEmployeeIdApproval: [],
    };
  },
  methods: {
    ...mapActions("remote-request", [
      "clearData",
      "getApprovalRemoteRequestInfo",
      "approveRemoteRequest",
    ]),
    moment,
    async open(request_id) {
      if (request_id) {
        await this.getApprovalRemoteRequestInfoById(request_id);
        this.listEmployeeIdApproval =
          this.approveInfo?.remote_request_approve || [];
        this.forms.id = request_id;
        this.isShow = true;
      } else {
        this.popupNotiTitle = "Lỗi";
        this.popupNoti = "Không tồn tại request ID";
        this.isShowPopupNoti = true;
      }
    },
    async onClickConfirm() {
      const isValid = await this.$refs.formCreate.validate();
      if (!isValid) return;
      this.showApprovalConfirm(true);
    },
    async onClickReject() {
      const isValid = await this.$refs.formCreate.validate();
      if (!isValid) return;
      this.showApprovalConfirm(false);
    },
    onClose() {
      this.resetForm();
      this.$refs.formCreate.reset();
      this.isShow = false;
    },

    resetForm() {
      this.forms.status = null;
      this.forms.reason = "";
      this.forms.id = "";
    },
    hidePopupNoti() {
      this.isShowPopupNoti = false;
    },
    async getApprovalRemoteRequestInfoById(id) {
      this.$root.$loading.start();
      await this.getApprovalRemoteRequestInfo(id);
      this.$root.$loading.finish();
    },
    showApprovalConfirm(approve_status) {
      if (approve_status) {
        this.approveConfirmTitle = "Xác nhận duyệt đơn Remote";
        this.forms.status = 2;
      } else {
        this.approveConfirmTitle = "Xác nhận từ chối đơn Remote";
        this.forms.status = 3;
      }
      this.isShowApprovalConfirm = true;
    },
    submitRemoteRequest() {
      this.$root.$refs.loading.start();
      this.approveRemoteRequest(this.forms)
        .then(() => {
          this.$toast(
            this.$t("popup.label_popup_approve_success"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
          this.$emit("getData");
          this.resetForm();
          this.$refs.formCreate.reset();
          this.hideApprovalConfirm();
          this.$store.dispatch('commons/getCountRequest');
          this.isShow = false;
        })
        .finally(() => {
          this.$root.$refs.loading.finish();
        });
    },
    hideApprovalConfirm() {
      this.isShowApprovalConfirm = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-input {
  margin-bottom: 16px;
  .form-field {
    .form-label {
      font-weight: 700;
      font-size: 14px;
      color: #303c54;

      .require {
        color: #f03d3e;
      }
    }

    /deep/ .ant-calendar-picker {
      width: 100%;

      .ant-input {
        height: 35px;
      }
    }

    .textarea-input {
      border: 1px solid #cfcfcf;
      border-radius: 10px;
    }

    .required {
      color: #f03d3e;
    }
  }
}
.save-info {
  margin-right: 10px;
  background-color: #3d4cdc;
  color: #fff;
}
.footer-btn {
  border-radius: 10px;
  width: 210px;
  height: 40px;
  font-weight: 700;
  font-size: 14px;
}
.cancel-btn {
  background-color: #ececec;
  color: #6f6f6f;
}
/deep/ .modal-content {
  border: unset;
  .warning-title {
    text-align: center;
  }
}

select {
-webkit-appearance: none;
text-indent: 1px;
text-overflow: '';
}
</style>

